import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
  providedIn: 'root'
})
export class OfferService {

    constructor(private httpService: HttpService) { }

  getOffers() {
    return new Promise((resolve, reject) => {

        let config = this.httpService.setHeaderConfig(true);

        this.httpService.get(UrlConnectionEnum.GET_OFFER_LIST, {}, config).subscribe({
            next: (data) => {
                resolve(data);
            },
            error: (error) => {
                reject(error);
            }
        })
    })
  }

}
